import React, { useEffect, useState } from 'react'

import './FeedPage.css'
import LiveCard from './custom-comp/LiveCard'
import LiveCardVideo from './custom-comp/LiveCardVideo'
import MultiSectionCard from './custom-comp/MultiSectionCard'
import UpcomingEvents from './custom-comp/UpcomingEvents'
import { Link } from 'react-router-dom'
import { useRef } from 'react';
import axios from 'axios'
import LiveCardSkeleton from './custom-comp/LiveCardSkeleton'
import FeedProfileSection from './custom-comp/FeedProfileSection'
import { TUP } from '../services/TUP'

export default function FeedPageUno() {

  const url = "https://partywitty.com/master/assets/uploads/";
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [isMuted, setIsMuted] = useState(false);
  const videoRef = useRef(null);
  const categoriesApiUrl = "https://partywitty.com/master/Api/getData/eventCategory";
  const allEventsApiUrl = "https://partywitty.com/master/APIs/ClubEvent/allEvents";

  const categoryWiseEventsApiUrl = "https://partywitty.com/master/APIs/ClubEvent/categoryWiseAllEvents";

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLatitude(latitude);
          setLongitude(longitude);
          fetchFeed(latitude, longitude);
        },
        (error) => {
          alert("Please enable Geo Location Service to find events in your locality.");
          console.error('Error in finding location: ', error);
        }
      );
    } else {
      console.error("Geolocation is not available in this browser.");
    }
  }, []);

  const toRad = (num) => {
    return num * Math.PI / 180;
  }

  const calculateDistance = (lat1, lon1, lat2, lon2) => {

    if (typeof lat1 !== 'number' || typeof lon1 !== 'number' || typeof lat2 !== 'number' || typeof lon2 !== 'number') {
      // console.log('lat-long', lat1, lon1, lat2, lon2);
      return -1;
    }

    var R = 6378137; // meters
    var dLat = toRad((lat2 - lat1));
    var dLon = toRad((lon2 - lon1));
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  }

  const fetchFeed = (lat, lon) => {
    TUP.sendTrigger('EA_GET_EVENT_FEED_LIST', { pageNo: 1, limit: 100 }).then(result => {
      console.log('Feed Result: ', result, lat, lon);
      const events = result.feeds?.map(f => {
        const data = f.data;
        data.distance = Math.round(calculateDistance(lat, lon, data.latitude, data.longitude) / 1000); // in KM
        return data;
      });

      setEvents(events);
    });
  }

  useEffect(() => {
    fetch(categoriesApiUrl)
      .then((response) => response.json())
      .then((data) => {
        setCategories(data.data);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setLatitude(latitude);
          setLongitude(longitude);
          // fetchAllEvents(latitude, longitude);
        },
        (error) => {
          alert("Please enable Geo Location Service to find events in your locality.");
          console.error('Error in finding location: ', error);
        }
      );
    } else {
      console.error("Geolocation is not available in this browser.");
    }
  }, [latitude, longitude]);

  const fetchAllEvents = (latitude, longitude) => {
    const formData = new FormData();
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
    setIsLoading(true);
    fetch(allEventsApiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.status === true) {
          setEvents(data.data);
        } else {
          setEvents([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching all events:", error);
      });
  };

  const fetchEventsByCategory = (latitude, longitude, categoryId) => {
    const formData = new FormData();
    formData.append("category_id", categoryId);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
    setIsLoading(true);
    fetch(categoryWiseEventsApiUrl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        setIsLoading(false);
        if (data.status === true) {
          setEvents(data.data);
        } else {
          setEvents([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching events by category:", error);
      });
  };

  const handleCategoryClick = (categoryId) => {
    if (selectedCategory !== categoryId) {
      setSelectedCategory(categoryId);
      // fetchEventsByCategory(latitude, longitude, categoryId);
    }
  };
  const handleMouseEnter = (videoId) => {
    if (videoRef.current) {
      videoRef.current.pause();
    }
    videoId.play();
    videoRef.current = videoId;
  };
  const handleMouseLeave = (videoId) => {
    videoId.pause();
    videoRef.current = null;
  };
  const toggleMute = () => {
    const video = videoRef.current;
    if (video) {
      video.muted = !video.muted;
      setIsMuted(video.muted);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [data, setData] = useState([]);
  const fetchURL = async () => {
    try {
      const response = await axios.get("https://partywitty.com/master/APIs/Common/getWebPromotionalBanner");
      setData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchURL();
  }, []);
  const filteredData = data.filter((banner) => banner.page_name === "Event" && banner.position === "partywitty");
  const eventUrl = (e) => {
    return `/${(e.cityName?.replace(/ /g, "-") || "").toLowerCase()}/${(e.areaName?.replace(/ /g, "-") || "").toLowerCase()}/${(e.clubName?.trim().split(/ +/).join("-").replace(/ /g, "-") || "").toLowerCase()}/event/${(e.name?.trim().split(/ +/).join("-").replace(/ /g, "-") || "").toLowerCase()}`;
  };




  return (
    <div className='feed-page'>
      <div className='live-reel-container'>

        <div className=''>
          <FeedProfileSection />
        </div>

        <div className='live-reel-header'>
          <div className='live-reel'>
            {events.length === 0 ? (
              Array.from({ length: 4 }).map((_, i) => <LiveCardSkeleton key={i} />)
            ) : (
              events.map((item) => (
                <div className="reel-item" key={item.id}>
                  <Link to={eventUrl(item)}>
                    {item.video ? (
                      <LiveCardVideo data={item} />
                    ) : (
                      <LiveCard data={item} />
                    )}
                  </Link>
                </div>
              ))
            )}
          </div>
        </div>

        <div className='f-upcoming-events-section'>
          <UpcomingEvents />
        </div>
      </div>
    </div >
  )
}
